module.exports = __webpack_public_path__ + "assets/img/Fm9PaS-qnEFv2dfAS4YXppxLlbo_.c0015b09.png";